import { gql } from '@apollo/client';

const Fragments = {
  documentClause: gql`
    fragment documentClause on DocumentClause {
      clauseId
      clauseCode
      clauseText
      orderNo
      formula
      parentClauseId
      parentClauseText
      clauseTypeId
      documentTypeId
      validityDays
      mandatory
      enabled
    }
  `
};

export default Fragments;
